<template>
  <div id="publishTask">
    <div class="task_container">
      <div class="container_item">
        <div class="title">
          <div class="title_txt">图片</div>
          <div class="title_info">（支持PNG格式，图片大小不得大于500MB）</div>
        </div>
        <el-upload
          action="/hrApi/file/uploadNew"
          list-type="picture-card"
          :class="fileList.length ? 'hidden' : ''"
          :file-list="fileList"
          :limit="1"
          :on-remove="onRemove"
          :on-success="onSuccess"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">是否推送封面图</div>
        </div>
        <el-radio v-model="radio" :label="1">是</el-radio>
        <el-radio v-model="radio" :label="0">否</el-radio>
      </div>
      <div class="container_item" v-if="radio">
        <div class="title">
          <div class="title_txt">推送封面图</div>
          <div class="title_info">（支持PNG格式，图片大小不得大于500MB）</div>
        </div>
        <el-upload
          action="/hrApi/file/uploadNew"
          list-type="picture-card"
          :file-list="fileListCover"
          :class="fileListCover.length ? 'hidden' : ''"
          :limit="1"
          :on-remove="onRemoveCover"
          :on-success="onSuccessCover"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">标题</div>
        </div>
        <el-input
          v-model="inputValue"
          placeholder="请输入标题"
          @input="inputChange"
        ></el-input>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">推送对象</div>
        </div>
        <div class="selectContainer" @click="jumpSelectPage">
          {{ selectValue || "请选择" }}
          <div class="total">
            +{{ selectValue ? selectValue.split(",").length : 0 }}
          </div>
        </div>
      </div>
      <div class="container_item">
        <div class="title">
          <div class="title_txt">时间</div>
        </div>
        <div class="date_picker_container">
          <el-date-picker
            v-model="datePickerValueStart"
            type="date"
            placeholder="开始日期"
            @input="datePickerValueInput"
          >
          </el-date-picker>
          <div>~</div>
          <el-date-picker
            v-model="datePickerValueEnd"
            :picker-options="datePickerOptions"
            type="date"
            placeholder="结束日期"
            @input="datePickerValueInput"
          >
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="btn_container">
      <el-button type="danger" @click="cancel"> 取消 </el-button>
      <el-button type="info" @click="saveDraft" :disabled="btnLoading">
        <img src="../../assets/medal/save_icon.png" alt="" /> 存草稿
      </el-button>
      <el-button type="primary" @click="releaseM" :disabled="btnLoading">
        <img src="../../assets/medal/release_icon.png" alt="" /> 发布
      </el-button>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/inside";
export default {
  data() {
    return {
      info: {},
      fileList: [],
      radio: 0,
      fileListCover: [],
      inputValue: "",
      options: [],
      selectValue: "",
      datePickerValueStart: "",
      datePickerValueEnd: "",
      btnLoading: false,
      datePickerOptions: {
        disabledDate: (date) => {
          return date < this.datePickerValueStart;
        },
      },
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    // 跳转选择推送对象页面
    jumpSelectPage() {
      sessionStorage.setItem("info", JSON.stringify(this.info));
      sessionStorage.setItem("radio", this.radio);
      this.$router.push({
        path: "/mobile/medal/treeView",
        query: {
          usernames: sessionStorage.getItem("usernames")
            ? sessionStorage.getItem("usernames")
            : this.info.usernames,
        },
      });
    },
    // 初始化数据
    initData() {
      // 编辑后url传参数据反显
      if (this.$route.query.info) {
        this.info = JSON.parse(this.$route.query.info);
      } else {
        // 推送对象跳转页面存储本地的数据
        this.info = JSON.parse(sessionStorage.getItem("info"));
      }
      console.log("this.info", this.info);
      // 获取树形结构筛选数据
      if (sessionStorage.getItem("changeInfoDepament")) {
        this.depament = JSON.parse(
          sessionStorage.getItem("changeInfoDepament")
        );
      }

      this.radio = Number(sessionStorage.getItem("radio"));
      if (this.info.pushCoverImageId && this.info.pushCoverImageId > 0) {
        this.radio = 1;
      } else {
        this.radio = 0;
      }

      this.inputValue = sessionStorage.getItem("inputValue") || this.info.title;
      this.selectValue =
        sessionStorage.getItem("nickname") || this.info.usernamesStr;
      console.log(this.selectValue, "this.selectValue");
      this.datePickerValueStart =
        sessionStorage.getItem("datePickerValueStart") ||
        this.info.reviewStartTime;
      this.datePickerValueEnd =
        sessionStorage.getItem("datePickerValueEnd") || this.info.reviewEndTime;
      this.fileList = this.info.picFilePath
        ? [{ url: "/hrApi" + this.info.picFilePath }]
        : [];
      this.fileListCover = this.info.pushCoverImageId
        ? [{ url: "/hrApi" + this.info.pushCoverImagePath }]
        : [];
    },
    // 输入框值改变
    inputChange() {
      sessionStorage.setItem("inputValue", this.inputValue);
    },
    // 确认选择时间
    datePickerValueInput() {
      sessionStorage.setItem("datePickerValueStart", this.datePickerValueStart);
      sessionStorage.setItem("datePickerValueEnd", this.datePickerValueEnd);
    },
    // 上传图片成功回调
    onSuccess(response) {
      this.info.picFileId = response.data.id;
      this.info.picFilePath = response.data.iconPath;
    },
    // 删除图片
    onRemove() {
      this.fileList = [];
    },
    // 上传封面图
    onSuccessCover(response) {
      this.info.pushCoverImageId = response.data.id;
      this.info.pushCoverImagePath = response.data.iconPath;
    },
    // 删除封面图
    onRemoveCover() {
      this.fileListCover = [];
      this.info.pushCoverImageId = 0;
    },
    //返回
    cancel() {
      this.$router.back();
    },
    // 存草稿
    saveDraft() {
      this.addOrUpdateTask(0, "已存草稿");
    },
    // 发布
    releaseM() {
      this.addOrUpdateTask(1, "发布成功");
    },
    // 添加或更新任务
    addOrUpdateTask(state, msg) {
      this.btnLoading = true;
      api
        .addOrUpdateTask({
          id: this.info.id,
          picFileId: this.info.picFileId,
          pushCoverImageId: this.radio ? this.info.pushCoverImageId : 0,
          taskStatus: state,
          // departmentId: this.info.departmentId,
          reviewStartTime: moment(this.datePickerValueStart).format(
            "YYYY-MM-DD"
          ),
          reviewEndTime: moment(this.datePickerValueEnd).format("YYYY-MM-DD"),
          title: this.inputValue,
          usernames: sessionStorage.getItem("usernames") || this.info.usernames,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: msg,
              type: "success",
            });
            this.cancel();
            this.btnLoading = false;
          }
        })
        .finally(() => {
          this.btnLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #publishTask {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #publishTask {
    width: 276px * $zoom;
  }
}
#publishTask {
  font-size: 16px * $zoom;
  position: relative;
  .task_container {
    width: 100%;
    min-height: 100vh;
    background: #fff;
    padding: 0 40px 150px;
    .container_item {
      .title {
        display: flex;
        align-items: flex-end;
        padding: 40px 0 20px 0;
        .title_txt {
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #282b32;
          line-height: 44px;
        }
        .title_info {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          color: #969b9e;
          line-height: 34px;
        }
      }
      .hidden {
        ::v-deep .el-upload {
          display: none;
        }
      }
      .selectContainer {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        position: relative;
        width: 100%;
        height: 72px;
        background: #f7f9fa;
        padding: 0 120px 0 30px;
        border-radius: 8px;
        font-size: 32px;
        line-height: 72px;
        color: #606266;
        .total {
          position: absolute;
          right: 30px;
          top: 0;
          color: #000;
        }
      }
      ::v-deep .el-input {
        .el-input__inner {
          width: 100%;
          height: 72px;
          background: #f7f9fa;
          border: none;
          border-radius: 8px;
          font-size: 32px;
          font-family: PingFangSC-Regular, PingFang SC;
          line-height: 72px;
          &::placeholder {
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            // color: #969B9E;
            color: #606266;
            line-height: 72px;
          }
        }
      }
      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 45%;
      }
      .date_picker_container {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      ::v-deep .el-input__icon {
        line-height: 72px;
        &::before {
          font-size: 32px;
        }
      }
    }
  }

  .btn_container {
    position: absolute;
    bottom: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 110px;
    background: #fff;
    .el-button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 92px;
      line-height: 92px;
      border: none;
      font-size: 32px;
      color: #ffffff;
      border-radius: 16px;
      img {
        width: 36px;
        height: 36px;
        margin-top: -5px;
        vertical-align: middle;
      }
    }
    .el-button--primary {
      background: #4ea27c;
    }
    .el-button--danger {
      background: #e65858;
    }
    .el-button--info {
      background: #f3f3f3;
      color: #282b32;
    }
  }
}
</style>
